import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Provider menu',
      options: {
        [null]: 'Seleziona provider menu',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Altro ristorante Foodamigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL Lieferando',
        placeholder: 'URL del ristorante su Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL Wolt',
        placeholder: 'URL del ristorante su Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Link Deliveroo del ristorante',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Apri il tuo ristorante su Deliveroo e copia il link dalla barra degli indirizzi.',
        error:
          'Inserisci il link alla pagina del menu di un ristorante su Deliveroo. Ha questo formato: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'URL Uber Eats',
        placeholder: 'URL del ristorante su Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Link GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Se usi la pagina di ordinazione GloriaFood:',
            description: 'Inserisci il tuo URL di ordinazione foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Se GloriaFood è integrato nel tuo sito web:',
            description: "Inserisci l'URL della pagina del tuo sito in cui compare il widget di ordinazione.",
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Inserisci un link valido che inizi con https://.',
        back_office_error:
          "Questo è un link del back-office di GloriaFood, non la pagina da cui i tuoi clienti ordinano. Apri la pagina d'ordine del tuo ristorante e incolla quel link.",
        wrong_platform_error:
          "Questo non sembra un link GloriaFood. Se usi la pagina di ordinazione ospitata da GloriaFood, inserisci il tuo URL di ordinazione foodbooking.com. Se GloriaFood è integrato nel tuo sito web, inserisci l'URL della pagina in cui compare il tuo widget di ordinazione.",
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL Thuisbezorgd',
        placeholder: 'URL del ristorante su Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL Takeaway.com',
        placeholder: 'URL del ristorante su Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL Pyszne.pl',
        placeholder: 'URL del ristorante su Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL Bistro.sk',
        placeholder: 'URL del ristorante su Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL Just Eat',
        placeholder: 'URL del ristorante su Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Link DoorDash del ristorante',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Apri il tuo ristorante su doordash.com e copia il link dalla barra degli indirizzi.',
        error: 'Inserisci il link a una pagina di ristorante DoorDash. Inizia con https://www.doordash.com/store/.',
        store_number_error:
          'Questo link contiene solo il numero del negozio. Apri il ristorante su doordash.com e copia il link con il suo nome, ad esempio https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Ristorante da cui copiare il menu',
        placeholder: 'Seleziona il ristorante da cui copiare il menu',
      },
    },
  },
};
